import { Typography } from "@mui/material";
import React from "react";

const PersonalFeedback = ({
  personalFeedback,
}: {
  personalFeedback: string;
}): React.JSX.Element => (
  <React.Fragment>
    <Typography variant="h6" color="initial" sx={{ mb: 1 }}>
      Persönliches Feedback
    </Typography>

    <Typography variant="body1" color="initial">
      {personalFeedback.length > 0 ? personalFeedback : "keine Angabe"}
    </Typography>
  </React.Fragment>
);
export default PersonalFeedback;
